export default "__VITE_PUBLIC_ASSET__40fc78a3__"